import {
	Box,
	Button,
	Divider,
	IconButton,
	Typography,
	useMediaQuery,
	useTheme,
	Tooltip,
} from "@mui/material";
import useStyles from "./styles";
import { CloseOutlined, HttpsOutlined } from "@mui/icons-material";
import GrupoChip from "../../../../../../components/grupoEconomico/GrupoChip";

export default function ServiceHeaderHostsConfig({
	loading = {},
	changed = false,
	editMode = false,
	selectedService = {},
	pendingNavigation = {},
	setEditMode = () => {},
	setConfirmacaoSaidaPagina = () => {},
	setSelectedService = () => {},
	handleCancel = () => {},
	handleSave = () => {},
	syncRunning = false,
}) {
	const theme = useTheme();
	const styles = useStyles(theme);
	const matches750 = useMediaQuery("(max-width:750px)");

	return (
		<Box sx={styles.container}>
			{matches750 && (
				<Box>
					<IconButton
						onClick={() => {
							if (!!changed && !!editMode) {
								pendingNavigation.current = { type: "close-drawer" };
								setConfirmacaoSaidaPagina(true);
								return;
							}
							setSelectedService(null);
						}}
					>
						<CloseOutlined />
					</IconButton>
				</Box>
			)}

			<Box sx={styles.row}>
				<Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
					<Typography variant="body2" fontWeight={700}>
						{`${selectedService?.id} - ${selectedService?.nome}`}
					</Typography>
					{selectedService?.ownerNome && (
						<GrupoChip label={selectedService.ownerNome} variant="owner" />
					)}
				</Box>

				<Tooltip title={syncRunning ? "A edição ficará indisponível durante a sincronização de ONUs" : ""}>
					<span>
						<Button
							variant="contained"
							size="small"
							startIcon={<HttpsOutlined />}
							disabled={syncRunning || Object.values(loading).some((value) => !!value)}
							onClick={() => {
								setEditMode(true);
							}}
						>
							Editar
						</Button>
					</span>
				</Tooltip>
			</Box>
			<Divider />
		</Box>
	);
}
